import React, {useEffect, useState} from 'react';
import {message, Select} from 'antd';
import request from "../../../../request";
import emiter, {_EVENTS} from "../../../../events";

type  props   = {
    url: any,
    labelKey: string | string[],
    valueKey: string,
    [key: string]: any,
    params?: any,
    separator?: string,
    needEnumMap?: {
        [key: string]: string,
    }
    resListPath?:string
}

const SPSelectWithApi: React.FC<props> = (props) => {
    const { url, labelKey, valueKey, params = {}, depLoadKeys, separator = '-', needEnumMap,
        enums, method, resListPath, onChange } = props
    const [options, setOptions] = useState<any>([]);
    const translateFn = (needEnumMap: any, labelKey: string, target: any) => {
        const res = enums?.[needEnumMap[labelKey]]?.find((i: any) => i.key === target)
        return res?.value
    }

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

    useEffect(() => {
        const obj = Object.assign({
            page: 1,
            page_size: 10000,
        }, params)
        request({
            url: url,
            method: method || 'GET',
            params: obj
        })
            .then((res: any) => {
                const arr = resListPath ? resListPath.split('.') : ['data']
                let data: any = res
                arr.forEach((item: any) => {
                    data = data[item]
                })
                const list = data?.map((item: any) => {
                    let label: string = ''
                    if (typeof labelKey === 'string') {
                        let str = item[labelKey]
                        if (needEnumMap && needEnumMap[labelKey]) {
                            str = translateFn(needEnumMap, labelKey, item[labelKey])
                        }
                        label = str
                    } else if (Array.isArray(labelKey)) {
                        labelKey.forEach((key: any) => {
                            let str = item[key]
                            if (needEnumMap && needEnumMap[key]) {
                                str = translateFn(needEnumMap, key, item[key])
                            }
                            label += label ? (separator + str) : str
                        })
                    }
                    return {
                        label: label,
                        value: item[valueKey],
                    }
                })
                setOptions(list);
            })
    }, (depLoadKeys || []));


    const onSeclectChange = (e: any) => {
      emiter.emit(_EVENTS.COMMON_EMIT.CAR_MODEL_CASCADER_PARAMS_EVENT, e)
      onChange(e)
    }

    return  <Select {...props} onChange={onSeclectChange} filterOption={filterOption} options={options}/>
};

export default SPSelectWithApi;
